import { create } from "zustand";

export const useWebSocketStatusStore = create((set) => ({
    status: "close",  // "open" | "connecting" | "closed" | "error"
    setStatus: (status) => set({ status }),
}));
